import { render, staticRenderFns } from "./EpAttorney.vue?vue&type=template&id=8c77265e&"
import script from "./EpAttorney.vue?vue&type=script&lang=ts&"
export * from "./EpAttorney.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports